import { useMutation } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';

export interface CancelBulkImportParams {
  jobId: string;
}

export interface CancelBulkImportResponse {
  success: boolean;
  message: string;
  jobId: string;
}

export const cancelBulkImportClassesAPI = async (
  params: CancelBulkImportParams,
) => {
  const response = await baseAPI.post<CancelBulkImportResponse>(
    `/enrollments/bulk-import-cancel/${params.jobId}`,
  );
  return response.data;
};

export const useCancelBulkImportClassesMutation = () => {
  return useMutation({
    mutationFn: cancelBulkImportClassesAPI,
  });
};
